__turbopack_context__.v({
  "connected": "VPadBanner-module__PuhGQa__connected",
  "connecting": "VPadBanner-module__PuhGQa__connecting",
  "content": "VPadBanner-module__PuhGQa__content",
  "contentTxt": "VPadBanner-module__PuhGQa__contentTxt",
  "contentWrapper": "VPadBanner-module__PuhGQa__contentWrapper",
  "ellipse": "VPadBanner-module__PuhGQa__ellipse",
  "icon": "VPadBanner-module__PuhGQa__icon",
  "statusLabel": "VPadBanner-module__PuhGQa__statusLabel",
  "suspended": "VPadBanner-module__PuhGQa__suspended",
  "vPadBanner": "VPadBanner-module__PuhGQa__vPadBanner",
});
